import {Button, Text, Toggle} from '@/components-v2/atoms'
import {useRewardFreeProductLists} from '@/containers/Promotions/components/PromotionsConditions/Rewards/useRewardFreeProductLists'
import PromotionSelectionModalV2 from '@/features/Promotions/components/PromotionSelectionModalV2'
import {ProductsDropdown, QuantityDropdown} from '../ConditionFields'

export const RewardFreeProductFromList = ({
  promotionCondition,
  rewardIndex = 0,
  selectedPromotionCondition,
  ModalComponent = PromotionSelectionModalV2,
}) => {
  const {
    isLoadingConfig,
    buyQtyOptions,
    productTypeOptions,
    freeProductLists,
    isMandatoryProductsEnabled,
    mandatoryQuantityValue,
    mandatoryProductsValue,
    mandatoryProductsText,
    isMandatoryQuantityError,
    isMandatoryProductsError,
    mandatoryProductsErrorMessage,
    modalProps,
    modalConditionValues,
    getListQuantityValue,
    getListProductsValue,
    getListProductsText,
    isListQuantityError,
    isListProductsError,
    isListQuantityRequired,
    isListProductsRequired,
    getListProductsErrorMessage,
    handleMandatoryProductsToggle,
    handleMandatoryQuantity,
    handleListQuantity,
    handleMandatoryProductsChange,
    handleListProductsChange,
    handleSubmitModal,
    handleCloseModal,
    addList,
    removeList,
  } = useRewardFreeProductLists({promotionCondition, rewardIndex, selectedPromotionCondition})

  return (
    <div
      className="grid w-full grid-cols-1 items-start gap-x-3 gap-y-3 min-[520px]:grid-cols-[auto_84px_auto_minmax(0,1fr)]"
      data-testid="free-product-from-list-fields"
    >
      <div className="col-span-full">
        <Toggle
          checked={isMandatoryProductsEnabled}
          onUpdate={handleMandatoryProductsToggle}
          size="small"
          label="Mandatory Products "
        />
      </div>
      {isMandatoryProductsEnabled && (
        <>
          <div className="hidden min-[520px]:block" />
          <QuantityDropdown
            options={buyQtyOptions}
            value={mandatoryQuantityValue}
            onChange={handleMandatoryQuantity}
            isLoading={isLoadingConfig}
            isRequired
            hasError={isMandatoryQuantityError}
            placeholder="Any"
            errorMessage="Required"
          />
          <div
            className="col-span-full flex min-w-0 items-start gap-2 min-[520px]:col-span-2"
            data-testid="mandatory-products-picker-row"
          >
            <ProductsDropdown
              options={productTypeOptions}
              value={mandatoryProductsValue}
              selectedText={mandatoryProductsText}
              onChange={handleMandatoryProductsChange}
              isLoading={isLoadingConfig}
              isRequired
              hasError={isMandatoryProductsError}
              errorMessage={mandatoryProductsErrorMessage}
            />
            <div className="pt-2">
              <Text> , and</Text>
            </div>
          </div>
        </>
      )}

      {freeProductLists.map((list, index) => (
        <div className="contents" key={`${list.groupName}-${index}`}>
          <div className="pt-2">
            <Text>Choose</Text>
          </div>
          <QuantityDropdown
            options={buyQtyOptions}
            value={getListQuantityValue(index)}
            onChange={values => handleListQuantity(index, values)}
            isLoading={isLoadingConfig}
            isRequired={isListQuantityRequired(index)}
            hasError={isListQuantityError(index)}
            placeholder="Any"
            errorMessage="Required"
          />
          <div className="pt-2">
            <Text>from {list.groupName}</Text>
          </div>
          <div className="flex min-w-0 items-start gap-2">
            <div className="min-w-0">
              <ProductsDropdown
                options={productTypeOptions}
                value={getListProductsValue(index)}
                selectedText={getListProductsText(index)}
                onChange={values => handleListProductsChange(index, values)}
                isLoading={isLoadingConfig}
                isRequired={isListProductsRequired(index)}
                hasError={isListProductsError(index)}
                errorMessage={getListProductsErrorMessage(index)}
              />
            </div>
            {index > 0 && (
              <Button
                variant="tertiary"
                size="small"
                iconLeading="delete"
                text="Delete list"
                onClick={() => removeList(index)}
              />
            )}
          </div>
        </div>
      ))}

      <div className="col-span-full">
        <Button variant="tertiary" size="small" iconLeading="add" text="Add List" onClick={addList} />
      </div>

      <div className="col-span-full">
        <ModalComponent
          key={`${modalProps.type}-${modalConditionValues.values.length}`}
          show={modalProps.show}
          type={modalProps.type}
          onClose={handleCloseModal}
          onSubmit={handleSubmitModal}
          conditionValues={modalConditionValues}
        />
      </div>
    </div>
  )
}
